import { combineReducers } from "redux";
import { LoginReducer } from "./LoginReducer";
const RootReducer = combineReducers({
   loggedInuser:LoginReducer,
  
   
})
export default RootReducer